import { db, storage } from "./Firebase"

const tblProducts = 'products'
const tblProductImages = 'product_images'

export default {
   getRef() {
      return db().ref(tblProductImages)
   },
   getRefByProduct(productId) {
      return db().ref(tblProductImages).orderByChild('product_id').equalTo(productId)
   },
   getProductImageById(id) {
      return db().ref(tblProductImages).child(id).once('value')
   },
   storeProductImage(obj) {
      let timestamp     = new Date().getTime()

      if (obj.file != null) {
         let file      = obj.file[0]
         let extension = file.name.replace(/.*\./g, "")
         let filename  = timestamp + '.' + extension

         const metadata = {
            contentType: file.type
         };

         let refImage = storage().ref('images').child(filename)

         return refImage.put(file, metadata).then(() => {
            refImage.getDownloadURL().then((url) => {
               let newProductImageKey = db().ref(tblProductImages).push().key

               let productImageData = {
                  id         : newProductImageKey,
                  src        : url,
                  filename   : filename,
                  main_status: obj.main_status,
                  product_id : obj.product_id != null ? obj.product_id: '',
                  created_at : timestamp,
                  updated_at : timestamp,
               }

               let updates = {}
               updates[`/${tblProductImages}/${newProductImageKey}`] = productImageData
               if (obj.product_id != '') {
                  updates[`/${tblProducts}/${obj.product_id}/product_images/${newProductImageKey}`] = true
                  if (obj.main_status == '1') {
                     updates[`/${tblProducts}/${obj.product_id}/src`] = url
                  }
               }

               db().ref().update(updates)
            })
         })
      }
   },
   updateMainStatus(objNew, objOld){
      let timestamp = new Date().getTime()

      let productImageNew = {
         id         : objNew.id,
         src        : objNew.src,
         filename   : objNew.filename,
         main_status: '1',
         product_id : objNew.product_id != null ? objNew.product_id: '',
         created_at : objNew.created_at,
         updated_at : timestamp
      }
      let productImageOld = {
         id         : objOld.id,
         src        : objOld.src,
         filename   : objOld.filename,
         main_status: '0',
         product_id : objOld.product_id != null ? objOld.product_id: '',
         created_at : objOld.created_at,
         updated_at : timestamp
      }

      let updates = {}
      updates[`/${tblProductImages}/${objNew.id}`] = productImageNew
      updates[`/${tblProductImages}/${objOld.id}`] = productImageOld

      if (productImageNew.main_status == '1') {
         updates[`/${tblProducts}/${productImageNew.product_id}/src`] = productImageNew.src
      }

      return db().ref().update(updates)
   },
   deleteProductImage(productImage) {
      let refImage = storage().ref('images').child(productImage.filename)

      return refImage.delete().then(()=> {
         let updates = {}
         updates[`/${tblProductImages}/${productImage.id}`] = null
         // eslint-disable-next-line
         if (!!productImage.product_id) {
            updates[`/${tblProducts}/${productImage.product_id}/product_images/${productImage.id}`] = null
         }

         db().ref().update(updates)
      })
   }
}
